module.exports = __webpack_public_path__ + "static/media/ic_cherry-pay.f7dbc063.svg";